import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store, { key } from "./store/store";
import vuetify from "./plugins/vuetify";
import VueGtag from "vue-gtag";
import "./assets/font.scss";

document
  .querySelector("meta[name='theme-color']")
  ?.setAttribute("content", vuetify.theme.current.value.colors["primary-darken-1"]);

const app = createApp(App).use(router).use(store, key).use(vuetify);

if (process.env.NODE_ENV === "production") {
  app.use(
    VueGtag,
    {
      config: {
        id: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID,
      },
    },
    router
  );
}

app.mount("#app");
